import React from "react";
import Button from "../Button";

const partners = [
  { name: "SOV", logo: "/images/partnerships/SOV.jpg", url: "https://www.specialolympics.com.au/", style: "font-extrabold text-spectrum-blue tracking-wider" },
  { name: "Atalgo", logo: "/images/partnerships/atalgo.jpg", url: null, style: "font-bold text-ink tracking-tight" },
  { name: "Best Chance", logo: "/images/partnerships/bestchance.jpg", url: "https://www.bestchance.org.au/", style: "font-semibold text-heart-teal text-center leading-tight" },
  { name: "Carevo", logo: "/images/partnerships/carevo.jpg", url: "https://carevo.com.au/", style: "font-extrabold text-sky-blue tracking-wide" },
  { name: "Envaedha", logo: "/images/partnerships/envaedha.jpg", url: "https://envaedha.com.au", style: "font-bold text-ink tracking-tight" },
  { name: "Flourish", logo: "/images/partnerships/Flourish.jpg", url: "https://www.flourishaustralia.org.au/", style: "font-semibold text-spectrum-blue italic" },
  { name: "Social Threads", logo: "/images/partnerships/social-threads.jpg", url: "https://www.socialthreads.au/", style: "font-bold text-ink text-center" },
  { name: "Soulful Learning", logo: "/images/partnerships/soulful-learning.jpg", url: "https://soulful-learning.com.au/", style: "font-bold text-spectrum-blue text-center" },
];

const PartnerTile = ({ partner }) => {
  const inner = (
    <div className="rounded-brand px-5 py-6 h-28 flex items-center justify-center border border-mist-hair bg-surface-white shadow-brand-sm hover:shadow-brand-md transition-shadow">
      <img
        src={process.env.PUBLIC_URL + partner.logo}
        alt={`${partner.name} logo`}
        className="max-h-[52px] max-w-full object-contain"
        onError={(e) => {
          e.target.style.display = "none";
          e.target.nextSibling?.classList.remove("hidden");
        }}
      />
      <span className={`hidden font-headline text-lg md:text-xl ${partner.style}`}>
        {partner.name}
      </span>
    </div>
  );

  if (partner.url) {
    return (
      <a
        href={partner.url}
        target="_blank"
        rel="noopener noreferrer"
        className="focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-sky-blue rounded-brand block"
      >
        {inner}
      </a>
    );
  }
  return inner;
};

/**
 * Partners — Stitch light band: surface-light wash, white elevated tiles.
 */
export const PartnersLight = () => (
  <section className="bg-surface-light py-16 md:py-24 text-left w-full relative overflow-hidden border-t border-mist-hair">
    <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
      <div className="mb-12 inline-block max-w-3xl">
        <div className="inline-block bg-cloud-mist text-spectrum-blue text-xs font-bold tracking-wider px-3.5 py-1 rounded-brand mb-3 font-headline">
          COLLABORATIONS & ALLIES
        </div>
        <h2 className="font-headline font-bold text-2xl sm:text-3xl lg:text-4xl text-ink mb-2">
          Organisations we proudly work with
        </h2>
        <div className="h-1.5 w-24 bg-sunshine rounded-full" aria-hidden="true" />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 mb-12">
        {partners.map((partner) => (
          <PartnerTile key={partner.name} partner={partner} />
        ))}
      </div>

      <Button to="/partnerships" variant="primary" size="md">
        Learn more about our partnerships →
      </Button>
    </div>
  </section>
);

const Partners = PartnersLight;
export default Partners;
